import { theme } from 'aimo-ui';
import CustomCarousel from 'components/common/CustomCarousel';
import useTutorialSheet from 'hooks/useTutorialSheet';
import { CountryCode } from 'types/generatedSchemaTypes';
import { isWeb } from 'utils/deviceUtils';
import { CarouselTutorialInfo, TutorialItem } from './TutorialComponents';

export type RemoteTutorial = {
  title: string;
  reviewable: boolean;
  tutorialId: string;
  countries?: CountryCode[];
  content: CarouselTutorialInfo[];
  forceOpen?: boolean;
};

const RemoteContentTutorial = () => {
  const { openedTutorial: tutorialId, selectedRemoteData } = useTutorialSheet(
    {}
  );

  if (selectedRemoteData) {
    return (
      <CustomCarousel
        carouselData={selectedRemoteData.content.map((item) => ({
          ...item,
          tutorialId,
        }))}
        width={theme.normalising.widthPixel(isWeb ? 500 : 320)}
        height={theme.normalising.heightPixel(500)}
        enabled
        carouselItem={TutorialItem}
      />
    );
  }
  return <></>;
};

export default RemoteContentTutorial;
